import Icon from '../components/Icon.vue'

Icon.register({"pause":{"width":448,"height":512,"paths":[{"d":"M144 479H48C21.5 479 0 457.5 0 431V79C0 52.5 21.5 31 48 31H144C170.5 31 192 52.5 192 79V431C192 457.5 170.5 479 144 479zM448 431V79C448 52.5 426.5 31 400 31H304C277.5 31 256 52.5 256 79V431C256 457.5 277.5 479 304 479H400C426.5 479 448 457.5 448 431z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pause.js
// module id = g29p
// module chunks = 0